import React, { useEffect, useState, useRef } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import kumarAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import bgImage from '../Assets/daily-journal-bg.png';
import TypingDots from '../Components/TypingDots';
import { callOpenAI } from '../utils/openaiService';

const quotes = [
  "Believe you can and you're halfway there. – Theodore Roosevelt",
  "Every day may not be good, but there’s something good in every day.",
  "Start where you are. Use what you have. Do what you can. – Arthur Ashe",
  "It’s not whether you get knocked down, it’s whether you get up. – Vince Lombardi",
  "You are capable of amazing things."
];

const DailyQuote = () => {
  const chatRef = useRef(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
    const introMessage = `🌟 Daily Quote: "${randomQuote}"

You crushed it today da! 👏🏽  
Before we bounce, wanna reflect on something that stood out?

It could be:
• A career that sparked interest  
• A new skill you want to learn  
• Or just how you’re feeling right now 🧘🏽‍♂️

Your future self will thank you for this. 💌`;

    setChatMessages([
      {
        sender: 'ai',
        avatar: kumarAvatar,
        name: 'Kumar',
        message: introMessage,
        timestamp: new Date().toLocaleString(),
      },
    ]);
  }, []);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [chatMessages, isTyping]);

  const handleSend = async (text) => {
    if (!text.trim()) return;
    setIsTyping(true);

    const userMsg = {
      sender: 'user',
      avatar: userAvatar,
      name: 'You',
      message: text,
      timestamp: new Date().toLocaleString(),
    };

    const updatedMessages = [...chatMessages, userMsg];
    setChatMessages(updatedMessages);

    const formattedMessages = updatedMessages.map((msg) => ({
      role: msg.sender === 'ai' ? 'assistant' : 'user',
      content: msg.message,
    }));

    const reply = await callOpenAI({
      messages: formattedMessages,
      screenContext: 'journal',
    });

    setChatMessages((prev) => [
      ...prev,
      {
        sender: 'ai',
        avatar: kumarAvatar,
        name: 'Kumar',
        message: reply,
        timestamp: new Date().toLocaleString(),
      },
    ]);
    setIsTyping(false);
  };

  return (
    <div
      className="relative rounded-[30px] shadow-xl p-6 flex flex-col justify-between min-h-[75vh] w-full max-w-[950px] mx-auto bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-white/0 rounded-[30px] z-0" />

      <div
        ref={chatRef}
        className="flex flex-col gap-6 overflow-y-auto flex-grow relative z-10 pr-2 custom-scroll max-h-[60vh]"
      >
        {chatMessages.map((msg, idx) => (
          <ChatBubble
            key={idx}
            sender={msg.sender}
            avatar={msg.avatar}
            name={msg.name}
            message={msg.message}
            timestamp={msg.timestamp}
            variant="white"
          />
        ))}

        {isTyping && (
          <ChatBubble
            sender="ai"
            avatar={kumarAvatar}
            name="Kumar"
            message={<TypingDots />}
            variant="white"
          />
        )}
      </div>

      <div className="mt-6 relative z-10">
        <MessageInput onSend={handleSend} />
      </div>
    </div>
  );
};

export default DailyQuote;